import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "column",
    marginBottom: "0.875rem",
  },
  title: {
    fontFamily: "Manrope, sans-serif",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "20px",
    color: "#308CDB !important",
    marginBottom: "1.25rem",
  },
  description: {
    fontFamily: "Manrope, sans-serif",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
    marginBottom: "1rem",
    lineHeight: "21px",
  },
  radioLabel: {
    "& .MuiFormControlLabel-label": {
      fontFamily: "Manrope, sans-serif",
      fontStyle: "normal",
      fontWeight: 500,
      fontSize: "0.875rem",
      color: "#465869",
    },
  },
  radioButton: {
    color: "#D0D5DD",

    "&.Mui-checked": {
      color: "#308CDB",
    },
  },
  buttonsSection: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginTop: 10,
  },
  uploadButton: {
    backgroundColor: "transparent",
    color: "#308CDB",
    border: "1px solid #308CDB",
    borderRadius: 8,

    display: "flex",
    alignItems: "center",
    gap: 14,

    "&:hover": {
      color: "#308CDB",
    },
  },
  mr12: {
    marginRight: 12,
  },
  mb0: {
    marginBottom: 0,
  },
  mb12: {
    marginBottom: 12,
  },
}));

export default styles;
